import { APP_PATHS, PAGE_PATHS } from '../../../types';

export type SoarApp = 'threats' | 'identities' | 'platform';

/**
 * The (app segment, base page segment) pair that owns each SOAR route tree.
 *
 * Both segments are needed: SOAR pages exist only under
 * `/{accountId}/threats/soc-automations/...` and
 * `/{accountId}/identities/idnp-automations/...`, so linking to a playbook from a
 * different app has to override the app segment too, not just the base page.
 */
export const SOAR_ROUTE: Record<SoarApp, { app: string; basePath: string }> = {
  threats: { app: APP_PATHS.THREATS, basePath: PAGE_PATHS.SOC_AUTOMATIONS },
  identities: { app: APP_PATHS.IDENTITIES, basePath: PAGE_PATHS.IDENTITY_AUTOMATIONS },
  platform: { app: APP_PATHS.PLATFORM, basePath: PAGE_PATHS.IDENTITY_AUTOMATIONS },
};

/**
 * Which SOAR route tree each host app links into. Add an entry when a new app starts
 * rendering SOAR components (e.g. the playbook picker on its ticket info); apps absent
 * from this map have no SOAR tree, and callers should hide their SOAR entry points.
 */
export const SOAR_APP_BY_HOST_APP: Record<string, SoarApp> = {
  [APP_PATHS.THREATS]: 'threats',
  [APP_PATHS.IDENTITIES]: 'identities',
  [APP_PATHS.PLATFORM]: 'platform',
};

/**
 * Returns true when the given entity type is within the provided scope.
 * An empty / undefined scope means "no scoping" (all entities allowed).
 */
export const matchesEntityScope = (entityType?: string, entityScope?: string[]): boolean => {
  if (!entityScope || entityScope.length === 0) return true;
  if (!entityType) return false;
  const normalized = entityType.toUpperCase().replace(/\s+/g, '_');
  return entityScope.includes(normalized);
};
